import { useState } from "react";
import { PUBLIC_LOGO_CANDIDATES } from "@/lib/utils.helpers";
import { useCompany } from "@/lib/company";

/**
 * <BrandLogo /> renders the MRS Enterprise logo.
 * - When authenticated: uses company.logo_url from settings (with cache-buster on refresh).
 * - When unauthenticated (public home/login): falls back to a candidate list of extensions.
 */
export default function BrandLogo({ className = "", alt = "MRS Enterprise" }) {
  const ctx = useCompany();
  const initial = ctx?.logoSrc || PUBLIC_LOGO_CANDIDATES[0];
  const [src, setSrc] = useState(initial);
  const [idx, setIdx] = useState(0);

  // If the context logoSrc changed (e.g. after upload), reflect it
  const preferred = ctx?.logoSrc;
  if (preferred && preferred !== src && idx === 0) {
    setSrc(preferred);
  }

  const onError = () => {
    const next = PUBLIC_LOGO_CANDIDATES[idx];
    if (next && next !== src) {
      setSrc(next);
      setIdx(idx + 1);
    }
  };

  return <img src={src} alt={alt} className={className} onError={onError} />;
}
